import { combineReducers } from 'redux';
import hallsReducer from './halls';
import boothsReducer from './booths';

export default combineReducers({
  halls: hallsReducer,
  booths: boothsReducer,
});
